import { css } from "@emotion/react"
import React from "react"
import { Navigation, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/bundle"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Swiper } from "swiper/react"
export default function Slider({ children, sliderSettings }) {
  return (
    <Swiper
      modules={[Pagination, Navigation]}
      navigation={sliderSettings.navigation}
      pagination={sliderSettings.pagination}
      slidesPerView={sliderSettings.slidesPerView}
      centerInsufficientSlides={true}
      spaceBetween={sliderSettings.spaceBetween}
      autoHeight={sliderSettings.autoHeight}
      css={theme => css`
        .swiper-pagination-bullet-active {
          background: ${theme.pink};
        }
      `}
    >
      {children}
    </Swiper>
  )
}
